var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExamination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1674 31.869C32.6796 29.4964 34.2714 26.163 34.2714 22.4426C34.2714 17.8588 31.8639 13.7244 28.1205 11.4024L32.3145 4.1428L31.6558 3.76312L32.6903 1.96424L29.9784 0.398804L28.9418 2.19487L28.2482 1.79437L17.9376 19.6549L18.8381 20.1746L17.5596 22.3864L19.8253 23.6947L21.1044 21.4819L22.0039 22.0016L26.3396 14.4928C27.6763 15.3448 28.7769 16.5197 29.5397 17.9092C30.3025 19.2988 30.7029 20.8581 30.7041 22.4432C30.7041 27.6407 26.4729 31.8696 21.2749 31.8696H13.6778V35.4386H35.0629V31.8696H30.1686L30.1674 31.869ZM11.1842 4.42405V1.59074H11.5329L11.5279 0.911241H8.35031L8.35538 1.59074H8.73V4.42405H6.35906V1.59074H6.70669L6.70275 0.911241H3.52238L3.52856 1.59074H3.90319V4.42405H0.421875V18.6165H14.6357V4.42405H11.1853H11.1842ZM13.4319 17.415H1.62394V5.62555H3.90263V14.6931C3.90263 15.3793 4.46344 15.9367 5.14013 15.9367C5.81794 15.9339 6.3585 15.3782 6.3585 14.6931V5.62555H8.72944V14.6931C8.72944 15.3793 9.29081 15.9367 9.9675 15.9367C10.6453 15.9339 11.1859 15.3782 11.1848 14.6931V5.62555H13.4319V17.415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamination);
export default __webpack_public_path__ + "static/media/examination.1183a418ac5701c0ab8aecc9d982ca6f.svg";
export { ForwardRef as ReactComponent };